/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



/**
=========================================================
* Material Dashboard 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import { createTheme } from "@mui/material";

// Material Dashboard 2 PRO React TS Base Styles
import colors from "dashboard-template/assets/theme/base/colors";
import breakpoints from "dashboard-template/assets/theme/base/breakpoints";
import typography from "dashboard-template/assets/theme/base/typography";
import boxShadows from "dashboard-template/assets/theme/base/boxShadows";
import borders from "dashboard-template/assets/theme/base/borders";
import globals from "dashboard-template/assets/theme/base/globals";

// Material Dashboard 2 PRO React TS Helper Functions
import boxShadow from "dashboard-template/assets/theme/functions/boxShadow";
import hexToRgb from "dashboard-template/assets/theme/functions/hexToRgb";
import linearGradient from "dashboard-template/assets/theme/functions/linearGradient";
import pxToRem from "dashboard-template/assets/theme/functions/pxToRem";
import rgba from "dashboard-template/assets/theme/functions/rgba";

// Material Dashboard 2 PRO React TS components base styles for @mui material components
import sidenav from "dashboard-template/assets/theme/components/sidenav";
import list from "dashboard-template/assets/theme/components/list";
import listItem from "dashboard-template/assets/theme/components/list/listItem";
import listItemText from "dashboard-template/assets/theme/components/list/listItemText";
import card from "dashboard-template/assets/theme/components/card";
import notificationWidget from "dashboard-template/assets/theme/components/widgets/notificationWidget";
import cardMedia from "dashboard-template/assets/theme/components/card/cardMedia";
import cardContent from "dashboard-template/assets/theme/components/card/cardContent";
import button from "dashboard-template/assets/theme/components/button";
import iconButton from "dashboard-template/assets/theme/components/iconButton";
import input from "dashboard-template/assets/theme/components/form/input";
import inputLabel from "dashboard-template/assets/theme/components/form/inputLabel";
import inputOutlined from "dashboard-template/assets/theme/components/form/inputOutlined";
import textField from "dashboard-template/assets/theme/components/form/textField";
import menu from "dashboard-template/assets/theme/components/menu";
import Grid from "dashboard-template/assets/theme/components/form/Grid";
import menuItem from "dashboard-template/assets/theme/components/menu/menuItem";
import switchButton from "dashboard-template/assets/theme/components/form/switchButton";
import divider from "dashboard-template/assets/theme/components/divider";
import tableContainer from "dashboard-template/assets/theme/components/table/tableContainer";
import tableHead from "dashboard-template/assets/theme/components/table/tableHead";
import tableCell from "dashboard-template/assets/theme/components/table/tableCell";
import linearProgress from "dashboard-template/assets/theme/components/linearProgress";
import breadcrumbs from "dashboard-template/assets/theme/components/breadcrumbs";
import slider from "dashboard-template/assets/theme/components/slider";
import avatar from "dashboard-template/assets/theme/components/avatar";
import tooltip from "dashboard-template/assets/theme/components/tooltip";
import appBar from "dashboard-template/assets/theme/components/appBar";
import tabs from "dashboard-template/assets/theme/components/tabs";
import tab from "dashboard-template/assets/theme/components/tabs/tab";
import stepper from "dashboard-template/assets/theme/components/stepper";
import step from "dashboard-template/assets/theme/components/stepper/step";
import stepConnector from "dashboard-template/assets/theme/components/stepper/stepConnector";
import stepLabel from "dashboard-template/assets/theme/components/stepper/stepLabel";
import stepIcon from "dashboard-template/assets/theme/components/stepper/stepIcon";
import select from "dashboard-template/assets/theme/components/form/select";
import formControlLabel from "dashboard-template/assets/theme/components/form/formControlLabel";
import formLabel from "dashboard-template/assets/theme/components/form/formLabel";
import checkbox from "dashboard-template/assets/theme/components/form/checkbox";
import radio from "dashboard-template/assets/theme/components/form/radio";
import autocomplete from "dashboard-template/assets/theme/components/form/autocomplete";
import accordion from "dashboard-template/assets/theme/components/accordion";
import flatpickr from "dashboard-template/assets/theme/components/flatpickr";
import container from "dashboard-template/assets/theme/components/container";
import popover from "dashboard-template/assets/theme/components/popover";
import buttonBase from "dashboard-template/assets/theme/components/buttonBase";
import icon from "dashboard-template/assets/theme/components/icon";
import svgIcon from "dashboard-template/assets/theme/components/svgIcon";
import link from "dashboard-template/assets/theme/components/link";
import dialog from "dashboard-template/assets/theme/components/dialog";
import dialogTitle from "dashboard-template/assets/theme/components/dialog/dialogTitle";
import dialogContent from "dashboard-template/assets/theme/components/dialog/dialogContent";
import dialogContentText from "dashboard-template/assets/theme/components/dialog/dialogContentText";
import dialogActions from "dashboard-template/assets/theme/components/dialog/dialogActions";
import editor from "dashboard-template/assets/theme/components/editor";

export default createTheme({
  breakpoints: { ...breakpoints },
  palette: { ...colors },
  typography: { ...typography },
  boxShadows: { ...boxShadows },
  borders: { ...borders },
  functions: {
    boxShadow,
    hexToRgb,
    linearGradient,
    pxToRem,
    rgba,
  },

  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ...globals,
        ...flatpickr,
        ...container,
        ...editor.MuiCssBaseline.styleOverrides,
      },
    },
    MuiDrawer: { ...sidenav },
    MuiList: { ...list },
    MuiListItem: { ...listItem },
    MuiListItemText: { ...listItemText },
    MuiCard: {
      ...card,
      styleOverrides: {
        ...card.styleOverrides,
        root: {
          ...card.styleOverrides.root,
          ...notificationWidget.styleOverrides.root,
        },
      },
    },
    MuiCardMedia: { ...cardMedia },
    MuiCardContent: { ...cardContent },
    MuiButton: { ...button },
    MuiIconButton: { ...iconButton },
    MuiInput: { ...input },
    MuiInputLabel: { ...inputLabel },
    MuiOutlinedInput: { ...inputOutlined },
    MuiAccordion: { ...accordion },
    MuiTextField: { ...textField },
    MuiGrid: { ...Grid },
    MuiMenu: { ...menu },
    MuiMenuItem: { ...menuItem },
    MuiSwitch: { ...switchButton },
    MuiDivider: { ...divider },
    MuiTableContainer: { ...tableContainer },
    MuiTableHead: { ...tableHead },
    MuiTableCell: { ...tableCell },
    MuiLinearProgress: { ...linearProgress },
    MuiBreadcrumbs: { ...breadcrumbs },
    MuiSlider: { ...slider },
    MuiAvatar: { ...avatar },
    MuiTooltip: { ...tooltip },
    MuiAppBar: { ...appBar },
    MuiTabs: { ...tabs },
    MuiTab: { ...tab },
    MuiStepper: { ...stepper },
    MuiStep: { ...step },
    MuiStepConnector: { ...stepConnector },
    MuiStepLabel: { ...stepLabel },
    MuiStepIcon: { ...stepIcon },
    MuiSelect: { ...select },
    MuiFormControlLabel: { ...formControlLabel },
    MuiFormLabel: { ...formLabel },
    MuiCheckbox: { ...checkbox },
    MuiRadio: { ...radio },
    MuiAutocomplete: { ...autocomplete },
    MuiPopover: { ...popover },
    MuiButtonBase: { ...buttonBase },
    MuiIcon: { ...icon },
    MuiSvgIcon: { ...svgIcon },
    MuiLink: { ...link },
    MuiDialog: { ...dialog },
    MuiDialogTitle: { ...dialogTitle },
    MuiDialogContent: { ...dialogContent },
    MuiDialogContentText: { ...dialogContentText },
    MuiDialogActions: { ...dialogActions },
  },
});
